import {
  BookingPendingFilter,
  BookingSpecialNeedsFilter,
} from '../../constants/enums';
import { GeneralFilters } from '../../models/app';
import { ACTIVATE_PAGE_EVENT, SET_PAGE_EVENT } from './pageEvents';

// actions
const SET = 'generalFilters/SET';
const SET_MULTIPLE = 'generalFilters/SET_MULTIPLE';
const CLEAR = 'generalFilters/CLEAR';

const DEFAULT_STATE: GeneralFilters = {
  searchText: '',
  fromDate: '',
  toDate: '',
  // Selected event of the page that is currently open: a mirror of
  // `pageEvents.byPage[activePage]`, set by <PageEventScope> before the page
  // renders. Each page has its own selection (helpers/selectedEvent.ts).
  event: '',
  ticket: '',
  wave: '',
  bookingsRegisteredFilter: BookingPendingFilter.NON_REGISTERED,
  bookingSpecialNeedsFilter: BookingSpecialNeedsFilter.No,
  bookingsOrigin: '',
  bookingsPaymentStatus: 0,
};

// reducer
const reducer = (state = DEFAULT_STATE, action: any = {}) => {
  switch (action.type) {
    case SET:
      return Object.assign({}, state, { [action.name]: action.value });
    case SET_MULTIPLE:
      return Object.assign({}, state, action.values);
    case ACTIVATE_PAGE_EVENT:
      return state.event === (action.eventId || '')
        ? state
        : Object.assign({}, state, { event: action.eventId || '' });
    case SET_PAGE_EVENT:
      return !action.mirror || state.event === (action.eventId || '')
        ? state
        : Object.assign({}, state, { event: action.eventId || '' });
    case CLEAR:
      // The page's selected event is NOT reset by clearing page filters (it
      // is owned by pageEvents; change it with useGlobalEvent().setEventId).
      return Object.assign({}, state, {
        searchText: '',
        fromDate: '',
        toDate: '',
        ticket: '',
        wave: '',
        bookingsRegisteredFilter: BookingPendingFilter.NON_REGISTERED,
        bookingSpecialNeedsFilter: BookingSpecialNeedsFilter.No,
        bookingsOrigin: '',
        bookingsPaymentStatus: 0,
      });
    default:
      return state;
  }
};

export default reducer;

// action creators
export const setGeneralFilters = (name: keyof GeneralFilters, value: any) => ({
  name,
  value,
  type: SET,
});

export const setGeneralFiltersMultiple = (values: Partial<GeneralFilters>) => ({
  values,
  type: SET_MULTIPLE,
});

export const clearGeneralFilters = () => ({
  type: CLEAR,
});
